import React, { useState, useEffect } from "react";
import {getFirestore, collection, query, where, getDocs, orderBy, doc, getDoc, setDoc, updateDoc} from "firebase/firestore";
import { app } from '../firebase.js';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import LeftBar from "../Components/LeftBar";
import NavBarAccount from "../Components/NavBarAccount";
import swal from 'sweetalert'; 
import { Table, Spinner, Button, Modal, Form } from "react-bootstrap";
import {useNavigate } from "react-router-dom";

function RewardsPoints() {

  const [pointsData, setPointsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);

  //more state
  const [userId, setUserId] = useState("");
  const [userName, setUserName] =  useState();
  const [pointValue, setPointValue] = useState("");
  const [issuedSMS, setissuedSMS] = useState();
  const [purchasedSMS, setPurchasedSMS] = useState();
  const [myissuedSMS, setMyissuedSMS] = useState();
  const [status, setStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("Unsubscribed");
  const [myTotalSMS, setMyTotalSMS] = useState();

  const [error, setError] = useState(''); 
  const auth = getAuth();
  const db = getFirestore(app);

  const [customer, setCustomer] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [totalPoints, setTotalPoints] = useState(0);
  const [redeemedPoints, setRedeemedPoints] = useState(0);
  const [availablePoints, setAvailablePoints] = useState(0);

  const [seetUpPountsValue, hasSeetUpPountsValue] = useState();
  const [pointValueSave, setPointValueSave] = useState(1);

  const [saveButton, setsaveButton] = useState("Save & Continue 🚀")



  // Fetch reward points
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        //console.log(uid)
        setUserId(uid);
        loadSettings(user.uid);
        fetchUserStatus(uid);
        checkPointsSetup(uid);
        const q = query(
          collection(db, "rewardCustomers"),
          where("businessId", "==", uid),
          orderBy("createdAt", "desc")
        );

        const querySnapshot = await getDocs(q);

        //console.log(querySnapshot);

        const pointsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPointsData(pointsList);
        setLoading(false);
        //console.log(pointsList )
      }
    });

 
    return () => unsubscribe();
  }, [auth, db]);

  //end that

  //read business info 

    const loadSettings = async (uid) => {
      const docRef = doc(db, "settings", uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPointValue(data.pointValue || "");   
      }
    };

    const fetchUserStatus = async (uid) => {
      const userQuery = query(collection(db, "users"), where("userId", "==", uid));
      const querySnapshot = await getDocs(userQuery);
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        setStatus(data.status || "Unsubscribed");
        setUserName(data.businessName);
        setPurchasedSMS(data.purchasedSMS);
        setMyissuedSMS(data.issuedSMS);
  
        const theissuedSMS = parseInt(data.issuedSMS);
        const myPurchasedSMS = data.purchasedSMS; 
  
        const totalSMS = theissuedSMS + myPurchasedSMS;
        setMyTotalSMS(totalSMS);
  
        // Subscription check
        const subscriptionEnd = data.subscriptionEnd?.toDate?.();
        if (subscriptionEnd) {
          const now = new Date();
          const isExpired = now > subscriptionEnd;
          setSubscriptionStatus(isExpired ? "Expired" : "Active");
        } else {
          setSubscriptionStatus("Unsubscribed");
        }
        
      });
    };
    //end

    //console.log(myTotalSMS)




  // Modal handlers
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
  };


  //

  const [show, setShow] = useState(false);

      // Modal handlers
  const handleOpen = () => setShow(true);
  const onClose = () => {
    setShow(false);
  };

  ///

  const handleAddCustomer = async () => {

    if (seetUpPountsValue == false){
        handleCloseModal()
        handleOpen();
        return;
    }

    if (!customerName || !customerPhone.match(/^(\+254|254|0)?(1|7)\d{8}$/)) {
      swal('Error', "Please enter a valid name and phone number", 'error');
      return;
    }

    if (myTotalSMS < 1){
      swal('insufficient SMS', "You have insufficient SMS credit to award a customer. Please top up your SMS balance to continue.", 'info').then(()=>{
         navigate("/settings");
      })
      return;
    }

    if (subscriptionStatus === "Expired"){
        swal('Subscription Expired', "Your subscription to this platform has expired. Renew your subscription to continue", 'info').then(()=>{
            navigate("/settings");
        })
        return;
    }



    const formattedPhone = formatPhoneNumber(customerPhone);
    

    try {
      setIsLoading(true);

      searchCustomer(formattedPhone);

    } catch (error) {
      console.error("Error adding customer:", error);
      alert("Failed to add customer.");
    } finally {
      setSubmitting(false);
    }
  };

  const searchCustomer = async (phoneSearch) => {
      setCustomer(null);
      setError("");
      setSuccessMsg("");
      setTotalPoints(0);
      setRedeemedPoints(0);
      setAvailablePoints(0);
  

      const q = query(
        collection(db, "rewardCustomers"),
        where("businessId", "==", userId),
        where("phone", "==", phoneSearch)
      );
  
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        const data = doc.data();
        const total = querySnapshot.size;
  
        setCustomer({ id: doc.id, ...data });
        setTotalPoints(total);
  
        const redeemQuery = query(
          collection(db, "redeemedPoints"),
          where("businessId", "==", userId),
          where("phone", "==", phoneSearch)
        );
        const redeemSnapshot = await getDocs(redeemQuery);
        let redeemedTotal = 0;
        redeemSnapshot.forEach(doc => {
          const redeemedData = doc.data();
          redeemedTotal += redeemedData.pointsUsed || 0;
        });
  
        const available = total - redeemedTotal;
        setRedeemedPoints(redeemedTotal);
        setAvailablePoints(available >= 0 ? available : 0);

        const myAvailablePoints = available >= 0 ? available : 0;
        //console.log(myAvailablePoints )
        recordPointsToDatabase(phoneSearch, myAvailablePoints);
      } else {
        setError("Customer not found.");
        const myAvailablePoints = 0
        recordPointsToDatabase(phoneSearch,myAvailablePoints );
      }
  };


  function recordPointsToDatabase(phoneSearch, myAvailablePoints){


      const totalRemainingPoints = myAvailablePoints + 1;
      const totalRemainingPointsValue = pointValue * totalRemainingPoints;

      //console.log(totalRemainingPointsValue)
      //console.log(totalRemainingPoints)

       const newDataRef = doc(collection(db, "rewardCustomers"));
        setDoc(newDataRef, {
            name: customerName,
            phone: phoneSearch,
            createdAt: new Date(),
            businessId: auth.currentUser.uid,
            points: 1,
            docID: newDataRef.id,
        }).then(() => {

            //read number of sms previously then minus 1 and update to the database 

            const newmyissuedSMS = parseInt(myissuedSMS);

            if (newmyissuedSMS >0){
                const newSMSBalance = newmyissuedSMS - 1;
                const savedSMSBalance = String(newSMSBalance);

                const userDocRef = doc(db, "users", userId); 
                updateDoc(userDocRef, {
                  issuedSMS: savedSMSBalance,
                }).then(()=>{     
                  const message = `Hey ${customerName}, you have been awarded 1 point at ${userName} worth ${pointValue}. Your total points are ${totalRemainingPoints}, worth KES ${totalRemainingPointsValue}. You can redeem these points for free services at ${userName}.`;
                  sendSmsNew(message, phoneSearch);    
                })

            }else if (purchasedSMS > 0){
                const newSMSBalance = purchasedSMS -1;

                const userDocRef = doc(db, "users", userId); 
                updateDoc(userDocRef, {
                  purchasedSMS: newSMSBalance,
                }).then(()=>{     
                  const message = `Hey ${customerName}, you have been awarded 1 point at ${userName} worth ${pointValue}. Your total points are ${totalRemainingPoints}, worth KES ${totalRemainingPointsValue}. You can redeem these points for free services at ${userName}.`;
                  sendSmsNew(message, phoneSearch);    
                })

            }


        });
  }



  const formatPhoneNumber = (number) => {
    // Strip non-numeric characters
    let cleaned = number.replace(/[^0-9]/g, '');

    // Handle various cases
    if (cleaned.startsWith('0')) {
      cleaned = '254' + cleaned.slice(1); // Replace leading 0 with 254
    } else if (cleaned.startsWith('254')) {
      // No change needed
    } else if (cleaned.startsWith('7')) {
      cleaned = '254' + cleaned; // Add 254 if starts with 7
    } else if (cleaned.startsWith('+254')) {
      cleaned = cleaned.slice(1); // Remove the + sign
    } else if (cleaned.startsWith('1')) {
      cleaned = '254' + cleaned; // For landlines or similar cases starting with 1
    }

    // Ensure the number has 12 digits
    if (cleaned.length === 12 && cleaned.startsWith('254')) {
      return cleaned;
    } else {
      setError('Please enter a valid phone number in the format 254XXXXXXXXX');
      return null;
    }
  };

  function formatFullDate(date) {
    if (!date) return "";

    const d = date instanceof Date ? date : date.toDate();

    const day = d.getDate();
    const weekday = d.toLocaleDateString("en-KE", { weekday: "long" });
    const month = d.toLocaleDateString("en-KE", { month: "long" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-KE", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    // Add ordinal suffix
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";

    return `${weekday} ${day}${suffix} ${month} ${year}, ${time}`;
  }



 
  //send sms
  const sendSmsNew = async (message, phoneNumber) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        console.error("User not logged in");
        return;
    }

    try {
        const token = await user.getIdToken();

        const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message, phoneNumber }),
        });

        const data = await response.json();

        if (response.ok) {
          swal("Success!", "Customer has been awarded 1 point successfully, and an SMS has been sent to them with their total points balance.", "success").then(() => {
            window.location.reload();
          });
        } else {
          swal("Success!", "Customer has been awarded 1 point successfully, and an SMS has been sent to them with their total points balance.", "success").then(() => {
            window.location.reload();
          });
        }
    } catch (err) {
        swal("Success!", "Customer has been awarded 1 point successfully, and an SMS has been sent to them with their total points balance.", "success").then(() => {
          window.location.reload();
        });
    }
  };
  //end sms
 

  const [checking, setChecking] = useState()

  const checkPointsSetup = async (uid) => {
    try {
      const docRef = doc(db, "settings", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        
        if (data.pointValue === undefined || data.pointValue === null) {
          hasSeetUpPountsValue(false); // Assuming this updates your state
        } else {
          hasSeetUpPountsValue(true); // or handle if pointValue is missing
        }

      } else {
        hasSeetUpPountsValue(false); // Assuming this updates your state
      }
    } catch (error) {
      console.error("Error checking sender ID application:", error);
    } finally {
      setChecking(false);
    }
  };

  //console.log(seetUpPountsValue)



  const handleSave = async () => {
    if (!pointValueSave || isNaN(pointValueSave)) {
      alert("Please enter a valid numeric point value.");
      return;
    }
    setsaveButton("Saving...");

    try {
      const docRef = doc(db, "settings", userId);
      await setDoc(docRef, {pointValue:pointValueSave } , { merge: true });
       setPointValue(pointValueSave);
      hasSeetUpPountsValue(true);
      onClose(); 
      handleOpenModal();
    } catch (error) {
      console.error("Error saving point value:", error);
      alert("Failed to save point value. Try again.");
    }
  };



  return (
    <div className="dashBCont">
      <LeftBar />
      <div className="dashBcontA">
        <NavBarAccount />
        <div className="container mt-5">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Customer Rewards</h4>
            <Button className="myPrimaryBtn" onClick={handleOpenModal}>
              Award Points
            </Button>
          </div>

          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" />
              <p>Loading points...</p>
            </div>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Points Earned</th>
                </tr>
              </thead>
              <tbody>
                {pointsData.length > 0 ? (
                  pointsData.map((item) => (
                    <tr key={item.id}>
                     <td>{formatFullDate(item.createdAt)}</td>
                      <td>{item.name}</td>
                      <td>{item.phone || "—"}</td>
                      <td>{item.points}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No points earned yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        {/* Add Customer Modal */}
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title className="myPrimaryColor">Award Points</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter first name"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. 0712345678"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="alert alert-primary">This user will receive an sms with 1 awarded point, their total points balance and how much they are worth</div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" className="btn-sm" onClick={handleCloseModal} disabled={submitting}>
              Cancel
            </Button>
            {IsLoading ? (
                <Button className="myPrimaryBtn" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                /> 
                  Submitting....
                </Button>
            ) : (
                <Button className="myPrimaryBtn" onClick={handleAddCustomer}>
                 Submit
                </Button>
            )}
            {/* <Button variant="primary" onClick={handleAddCustomer} disabled={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </Button> */}
          </Modal.Footer>
        </Modal>

        <Modal show={show} onHide={onClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Set Up how much 1 Point is worth</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ marginBottom: "1rem" }}>
              You haven’t set how much 1 point is worth yet. Let’s quickly fix that so you can start rewarding your customers like a pro!
            </p>
            <Form.Group>
              <Form.Label>💰 How much is 1 point worth (in KES)?</Form.Label>
              <Form.Control
                type="number"
                value={pointValueSave}
                onChange={(e) => setPointValueSave(e.target.value)}
                placeholder="e.g. 10"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
              Not Now
            </Button>
            
            <Button variant="primary" onClick={handleSave}>
              {saveButton}
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
}

export default RewardsPoints;